import { useMemo } from 'react';

import {
  MetricBarChart,
  MetricCardProps,
  MetricPanel,
  MetricTimePoint,
} from '@occc/ui-design-system';
import {
  RetailerNetworkTobaccoProgramMetricType,
  RetailerNetworkTobaccoProgramPerformanceFragment,
} from '@occc/graphql';

import { getTobaccoPerformanceMetrics } from './tobacco-performance-metric-builder';

type RetailerNetworkTobaccoPerformanceProps = {
  metrics: MetricTimePoint[];
  onMetricClick: (metricCard: MetricCardProps<RetailerNetworkTobaccoProgramMetricType>) => void;
  totalTransactions: number;
  prevTotalTransactions: number;
  performance: RetailerNetworkTobaccoProgramPerformanceFragment;
  previousPerformance: RetailerNetworkTobaccoProgramPerformanceFragment;
};

export const RetailerNetworkTobaccoPerformance = ({
  metrics,
  onMetricClick,
  totalTransactions,
  prevTotalTransactions,
  performance,
  previousPerformance,
}: RetailerNetworkTobaccoPerformanceProps) => {
  const {
    grouped: {
      member: tobaccoMemberMetrics,
      loyalty: tobaccoLoyaltyMetrics,
      multiUnit: tobaccoMultiUnitMetrics,
    },
  } = useMemo(
    () => getTobaccoPerformanceMetrics(performance, previousPerformance),
    [performance, previousPerformance],
  );

  return (
    <>
      <MetricPanel
        metrics={[
          {
            label: 'Total Tobacco Transactions',
            value: totalTransactions,
            prevValue: prevTotalTransactions,
            sx: { flexGrow: 2 },
          },
        ]}
      >
        <MetricBarChart metrics={metrics} />
      </MetricPanel>
      <MetricPanel<RetailerNetworkTobaccoProgramMetricType>
        title='Tobacco Members'
        metrics={tobaccoMemberMetrics}
        onClick={onMetricClick}
      />
      <MetricPanel<RetailerNetworkTobaccoProgramMetricType>
        title='Tobacco Loyalty'
        hint='(Updated Daily)'
        metrics={tobaccoLoyaltyMetrics}
        onClick={onMetricClick}
      />
      <MetricPanel<RetailerNetworkTobaccoProgramMetricType>
        title='Tobacco Multi-Unit'
        hint='(Updated Weekly)'
        metrics={tobaccoMultiUnitMetrics}
        onClick={onMetricClick}
      />
    </>
  );
};
